import { Component, computed, input, output } from '@angular/core';
import { DocumentRequestForm } from '@forms/document-request-form';
import {
  TiimeAlertModule,
  TiimeButtonModule,
  TiimeFormModule,
  TiimeIconModule,
  TiimeInputContainerModule,
  TiimeSelectModule,
  TiimeTooltipModule
} from 'tiime-material';
import { DocumentRequestModuleTypeSelectComponent } from '@shared-selectors/document-request-type-select/document-request-module-type-select.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DocumentRequestModuleType } from '@enums/document-request-module-type.enum';
import { TextFieldModule } from '@angular/cdk/text-field';
import { AccountingPeriod } from '@models/accounting-period';
import { DateHelper } from '@helpers/date.helper';
import { Subscription } from 'rxjs';
import { DocumentRequestPanelMode } from '@modules/core/component-stores/document-requests.store';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-document-request-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TiimeInputContainerModule,
    TiimeSelectModule,
    TiimeFormModule,
    DocumentRequestModuleTypeSelectComponent,
    TextFieldModule,
    TiimeAlertModule,
    TiimeIconModule,
    TiimeTooltipModule,
    TiimeButtonModule
  ],
  templateUrl: './document-request-form.component.html',
  styleUrl: './document-request-form.component.scss'
})
export class DocumentRequestFormComponent {
  readonly documentRequestForm = input.required<DocumentRequestForm>();
  readonly firstOpenedAccountingPeriod = input.required<AccountingPeriod>();
  readonly panelMode = input.required<DocumentRequestPanelMode>();
  readonly maximumSize = input.required<number>();
  readonly acceptedTypes = input.required<string[]>();
  readonly downloadTemplateFile = output<DocumentRequestModuleType>();
  readonly onFileSelected = output<File>();
  readonly onFileDeleted = output<void>();
  readonly DocumentRequestModuleType = DocumentRequestModuleType;
  readonly DocumentRequestModuleTypeArray: DocumentRequestModuleType[] = Object.values(DocumentRequestModuleType);
  readonly subscriptions: Subscription = new Subscription();

  readonly accountingPeriodString = computed(() => {
    if (!this.firstOpenedAccountingPeriod()) {
      return '';
    }
    const fromDate = DateHelper.format(this.firstOpenedAccountingPeriod().startDate, 'DD/MM/YYYY');
    const toDate = DateHelper.format(this.firstOpenedAccountingPeriod().endDate, 'DD/MM/YYYY');
    return `Du ${fromDate} au ${toDate}`;
  });

  onDownloadTemplateClick(): void {
    this.downloadTemplateFile.emit(this.documentRequestForm().moduleType.value);
  }
}
